<div class="d-flex flex-column justify-content-center align-items-center h-100">
  <div class="position-relative">
    <img
      class="img-fluid"
      src="/imgs/empty-box.png"
      [alt]="'SYSTEM_COMPONENTS.COMING_SOON.IMAGE_ALT' | translate" />
  </div>
  <div class=" fw-bolder fa-lg m-3">{{ 'SYSTEM_COMPONENTS.COMING_SOON.TITLE' | translate }}</div>
  <div class="text-muted">{{ 'SYSTEM_COMPONENTS.COMING_SOON.DESCRIPTION' | translate }}</div>
</div>
